import { getCore as get } from "../../utils/httpInterceptor";

/**
 * Custom (hand-written) service for CustInvoiceTrans (posted customer invoice
 * lines). Backend contract: CustInvoiceTransController
 * (@RequestMapping("/api/legacy/cust-invoice-trans")). Read-only from the
 * frontend's perspective - only the /last-sales endpoint is consumed, by the
 * "Ultimas Ventas" tab of the SelectorBobinas (CMTSelectorBobinas) replica.
 */

const BASE_PATH = "/api/legacy/cust-invoice-trans";

const toQueryString = (params) => {
  const query = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, String(value));
    }
  });
  return query.toString();
};

class custInvoiceTransService {
  /** GET /last-sales?dataAreaId=&custAccount=&limit= -> CustInvoiceTransDTO[] */
  static async getLastSales(dataAreaId, custAccount, limit = 50) {
    if (!custAccount) return [];
    const qs = toQueryString({ dataAreaId, custAccount, limit });
    return get(`${BASE_PATH}/last-sales?${qs}`);
  }
}

export default custInvoiceTransService;
